/**
 * Layout Store
 *
 * Zustand store definition for layout state.
 *
 * @module @store/layout/layoutStore
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { LayoutState, LayoutActions } from './layoutTypes';
import { checkDevEnv } from '@shared/utils/env';
import { createLayoutActions } from './layoutActions';

const initialState: LayoutState = {
    isNavbarExpanded: true,
};

/**
 * Zustand store for layout state.
 */
export const useLayoutStore = create<LayoutState & LayoutActions>()(
    devtools(
        (set): LayoutState & LayoutActions => ({
            ...initialState,
            ...createLayoutActions(set),
        }),
        { enabled: checkDevEnv(), name: 'layoutStore' },
    ),
);
